import { useNavigate } from 'react-router-dom';
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup"
import { ingredientSchema } from '../schema';
import { FormInput } from '@/components/forms/FormInput';
import { FormCheckbox } from '@/components/forms/FormCheckbox';
import { IngredientNutritionFields } from './IngredientNutritionFields';
import { Stack } from '@mui/joy';
import { FormButtons } from '@/components/FormButtons.jsx';
import { CategoryPicker } from '@/features/categories/components/CategoryPicker';
import { UnitsSelect } from '@/features/units/components/UnitsSelect';

export function IngredientForm({ data, save, saveResult }) {
  const navigate = useNavigate();  
  
  const form = useForm({
    defaultValues: data,
    resolver: yupResolver(ingredientSchema)
  });

  async function onSubmit(data) {
    const result = await save(data);
    if (result.error) {
      console.error(result.error);
    } else {
      navigate('..');
    }      
  }

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Stack
          spacing={2}
          sx={{
            display: 'flex',
            pt: 2,
            pb: 3,
          }}
        >          
          <FormInput 
            name="name" 
            label="Ingredient Name" 
            placeholder="Enter ingredient name"
          />
          <CategoryPicker
            name="subcategory_id"
            label="Category"
            allowExistingSubcategories={true}
          />
          <UnitsSelect name="preferred_unit" label="Preferred Unit" />
          <FormCheckbox name="common" label="Common ingredient" />
          <IngredientNutritionFields />
        </Stack>
        <FormButtons isSaving={saveResult.isLoading} />
      </form>
    </FormProvider>
  );
}
